import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIBillingSystemsGetList } from './BillingSystems.api';

export const fetchBillingSystems = createAsyncThunk('billingSystems/fetchBillingSystems', async () => {
    const response = await APIBillingSystemsGetList();
    return response.data;
});
